import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {
  ContractInsurableObjectType,
  ContractsRuntimeObjectDto,
} from "../../types/contracts.types";
import {Router} from "@angular/router";


@Component({
  selector: 'app-insurable-objects',
  templateUrl: './insurable-objects.component.html',
  styleUrls: ['insurable-objects.component.scss']
})
export class InsurableObjectsComponent extends CoreComponent implements OnInit, OnChanges {

  @Input() insurableObjects?: ContractsRuntimeObjectDto[];
  @Input() showContractCount: boolean = true;

  selectedObject?: ContractsRuntimeObjectDto;
  showEditDialog: boolean = false;

  constructor(
    protected router: Router,) {
    super();
  }


  override ngOnInit() {
    super.ngOnInit();
    this.refreshComponent();
  }

  refreshComponent() {

    this.initialized = true;
  }

  showContractsForObject(insurableObject: ContractsRuntimeObjectDto) {

    if (ContractInsurableObjectType.OBJECT == insurableObject.objectType) {
      this.router.navigate(['/ds/contracts'], {queryParams: {insurableObject: insurableObject.filterId}});
    } else if (ContractInsurableObjectType.PERSON == insurableObject.objectType || ContractInsurableObjectType.ME == insurableObject.objectType) {
      this.router.navigate(['/ds/contracts'], {queryParams: {insurablePerson: insurableObject.filterId}});
    }

  }

  openEditDialog(insurableObject: ContractsRuntimeObjectDto, event: MouseEvent) {
    event.stopPropagation();
    this.selectedObject = { ...insurableObject };
    this.showEditDialog = true;
  }


}
